export default __webpack_public_path__ + "static/media/trecking-2.88861464.png";